import getCurrentLocaleFromSources from './getCurrentLocaleFromSources'

export const customDetectorConfig = {
  customDetector: {
    name: 'detectLocaleInUrl',
    lookup() {
      return getCurrentLocaleFromSources()
    },
  },
  detectorOptions: {
    order: ['detectLocaleInUrl', 'navigator'],
  },
}

export default customDetectorConfig
